import { get } from 'lodash';
import { HttpService } from 'app/services';
import * as AppActions from 'app/store/actions';
import { parseError } from 'helpers/Error';
import { changePharmacyConfigurationForm } from './update.configuration.actions';

export const START_VPB_HISTORY_SUMMARY_BACKFILL = '@PHARMACY/TOOLS_START_VPB_HISTORY_SUMMARY_BACKFILL';
export const END_VPB_HISTORY_SUMMARY_BACKFILL = '@PHARMACY/TOOLS_END_VPB_HISTORY_SUMMARY_BACKFILL';
export const START_VPB_HISTORY_SUMMARY_SETTING = '@PHARMACY/TOOLS_START_VPB_HISTORY_SUMMARY_SETTING';
export const END_VPB_HISTORY_SUMMARY_SETTING = '@PHARMACY/TOOLS_END_VPB_HISTORY_SUMMARY_SETTING';
export const SET_VPB_HISTORY_SUMMARY_BACKFILL_RUNNING = '@PHARMACY/TOOLS_SET_VPB_HISTORY_SUMMARY_BACKFILL_RUNNING';

const parseBackfillRunningResponse = (response) =>
  get(response, 'data.isRunning', get(response, 'Data.IsRunning', false)) === true;

function setVpbHistorySummaryBackfillQueued(dispatch) {
  dispatch({
    type: SET_VPB_HISTORY_SUMMARY_BACKFILL_RUNNING,
    payload: { isRunning: true, statusLoaded: true },
  });
}

export function fetchVpbHistorySummaryBackfillRunning(pharmacyId, { initialLoad = false } = {}) {
  return (dispatch, getState) => {
    if (initialLoad) {
      dispatch({ type: SET_VPB_HISTORY_SUMMARY_BACKFILL_RUNNING, payload: { statusLoaded: false } });
    }
    return HttpService.get(`/api/background-jobs/vpb-history-summary/${pharmacyId}/running`)
      .then((response) => {
        const isRunning = parseBackfillRunningResponse(response);
        dispatch({
          type: SET_VPB_HISTORY_SUMMARY_BACKFILL_RUNNING,
          payload: { isRunning, statusLoaded: true },
        });
        return isRunning;
      })
      .catch((err) => {
        const { errorMessages, errorTitle } = parseError(err);
        dispatch(AppActions.createDialogMessage('error', errorTitle, errorMessages));
        dispatch({ type: SET_VPB_HISTORY_SUMMARY_BACKFILL_RUNNING, payload: { statusLoaded: true } });
        return getState().pharmacy.update.tools.backfillJobRunning;
      });
  };
}

export function updateVpbHistorySummarySetting(pharmacyId, enableVPBHistorySummary) {
  return (dispatch, getState) => {
    dispatch({ type: START_VPB_HISTORY_SUMMARY_SETTING });
    HttpService.put(`/api/pharmacies/${pharmacyId}/vpb-history-summary`, {
      enableVPBHistorySummary,
    })
      .then(() => {
        if (!enableVPBHistorySummary) {
          const { data } = getState().pharmacy.update.configuration;
          dispatch(changePharmacyConfigurationForm({ ...data, enableVPBHistorySummary: 'false' }));
        } else {
          setVpbHistorySummaryBackfillQueued(dispatch);
        }
        dispatch(
          AppActions.showMessage({
            message: enableVPBHistorySummary
              ? 'pharmacy:VPB_HISTORY_SUMMARY_ENABLE_QUEUED_MESSAGE'
              : 'pharmacy:VPB_HISTORY_SUMMARY_DISABLED_MESSAGE',
            autoHideDuration: 4000,
            anchorOrigin: {
              vertical: 'top',
              horizontal: 'right',
            },
            variant: 'success',
          }),
        );
      })
      .catch((err) => {
        const { errorMessages, errorTitle } = parseError(err);
        dispatch(AppActions.createDialogMessage('error', errorTitle, errorMessages));
        if (get(err, 'response.status') === 409) {
          setVpbHistorySummaryBackfillQueued(dispatch);
        }
      })
      .finally(() => {
        dispatch({ type: END_VPB_HISTORY_SUMMARY_SETTING });
      });
  };
}

export function startVpbHistorySummaryBackfill(pharmacyId) {
  return (dispatch) => {
    dispatch({ type: START_VPB_HISTORY_SUMMARY_BACKFILL });
    HttpService.post(`/api/pharmacies/${pharmacyId}/vpb-history-summary/backfill`)
      .then(() => {
        setVpbHistorySummaryBackfillQueued(dispatch);
        dispatch(
          AppActions.showMessage({
            message: 'pharmacy:VPB_HISTORY_SUMMARY_BACKFILL_QUEUED_ENABLE_ON_SUCCESS_MESSAGE',
            autoHideDuration: 4000,
            anchorOrigin: {
              vertical: 'top',
              horizontal: 'right',
            },
            variant: 'success',
          }),
        );
      })
      .catch((err) => {
        const { errorMessages, errorTitle } = parseError(err);
        dispatch(AppActions.createDialogMessage('error', errorTitle, errorMessages));
        if (get(err, 'response.status') === 409) {
          setVpbHistorySummaryBackfillQueued(dispatch);
        }
      })
      .finally(() => {
        dispatch({ type: END_VPB_HISTORY_SUMMARY_BACKFILL });
      });
  };
}
